import { AdminHeader } from '@vgrubs/components';
import { SystemProblemsTab } from './SystemProblemsTab';

/**
 * System Problems as a page of its own in the sidebar. It used to be a
 * Dashboard tab; the Orders tab's urgent bar still links here.
 */
export const SystemProblems = () => (
  <>
    <AdminHeader title="System Problems" />
    <SystemProblemsTab />
  </>
);
